import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Blogs from './pages/Blogs/Blogs';
import Home from './pages/Home/Home/Home';
import ProjectDetails from './pages/ProjectDetails/ProjectDetails';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home></Home>}>
          </Route>
          <Route path="/myProjects/:index" element={<ProjectDetails/>}>
          </Route>
          <Route path="/blogs" element={<Blogs/>}>
          </Route>
        </Routes>
        </BrowserRouter>
    </>
  );
}

export default App;
